export const common = {
  // Header
  'header.home': '首页',
  'header.about': '关于我们',
  'header.faq': '常见问题',
  'header.contact': '联系我们',
  'header.signIn': '登录',
  'header.getStarted': '开始使用',

  // Footer
  'footer.tagline': '提升您的财务未来',
  'footer.description': '为全球个人和企业提供安全、可靠和创新的支付解决方案。',
  'footer.quickLinks': '快速链接',
  'footer.services': '服务',
  'footer.contact': '联系我们',
  'footer.address': '789 Summit Avenue, San Francisco, CA 94102',
  'footer.email': 'support@pinnaclepayments.com',
  'footer.phone': '+1 (415) 555-1234',
  'footer.copyright': '© 2024 Pinnacle Payments. 版权所有。',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',

  // Home Page
  'home.hero.title': '提升您的财务未来',
  'home.hero.subtitle': '体验尖端技术带来的无缝银行服务。使用 Pinnacle Payments 管理您的财富、明智投资并实现您的财务目标。',
  'home.hero.cta': '立即开始',
  'home.hero.learn': '了解更多',

  'home.stats.users': '活跃用户',
  'home.stats.countries': '服务国家',
  'home.stats.transactions': '处理交易',
  'home.stats.support': '全天候支持',

  'home.services.title': '我们的优质服务',
  'home.services.subtitle': '为您的需求量身定制的全面金融解决方案',

  'home.services.banking.title': '数字银行',
  'home.services.banking.desc': '现代银行服务触手可及,提供即时转账、账单支付和实时余额跟踪。',

  'home.services.investment.title': '投资解决方案',
  'home.services.investment.desc': '通过我们精选的投资组合和专家财务指导增加您的财富。',

  'home.services.loans.title': '灵活贷款',
  'home.services.loans.desc': '快速批准的个人和商业贷款,具有竞争力的利率和灵活的还款条件。',

  'home.services.cards.title': '虚拟卡',
  'home.services.cards.desc': '安全的虚拟借记卡和信用卡,用于安全的在线购物和国际交易。',

  'home.features.title': '为什么选择 Pinnacle Payments',
  'home.features.subtitle': '体验行业领先功能的银行卓越服务',

  'home.features.security.title': '银行级安全',
  'home.features.security.desc': '您的资金受到军事级加密和多因素身份验证的保护。',

  'home.features.instant.title': '即时转账',
  'home.features.instant.desc': '在 180 多个国家即时发送和接收资金,零延迟。',

  'home.features.support.title': '全天候专家支持',
  'home.features.support.desc': '我们的专业团队随时为您解答任何问题或疑虑。',

  'home.features.rates.title': '竞争性汇率',
  'home.features.rates.desc': '享受行业内所有交易的最佳汇率和最低费用。',

  'home.plans.title': '财务增长计划',
  'home.plans.subtitle': '选择完美的计划来实现您的财务目标',

  'home.plans.dps.title': '存款养老金计划',
  'home.plans.dps.rate': '年回报率',
  'home.plans.dps.term': '灵活条款',
  'home.plans.dps.feature1': '每月存款选项',
  'home.plans.dps.feature2': '保证回报',
  'home.plans.dps.feature3': '税收优惠',
  'home.plans.dps.feature4': '提前提款选项',
  'home.plans.dps.cta': '开始储蓄',

  'home.plans.fdr.title': '定期存款收据',
  'home.plans.fdr.rate': '利率',
  'home.plans.fdr.term': '锁定期',
  'home.plans.fdr.feature1': '保证高回报',
  'home.plans.fdr.feature2': '灵活的期限选项',
  'home.plans.fdr.feature3': 'FDR 抵押贷款',
  'home.plans.fdr.feature4': '可自动续期',
  'home.plans.fdr.cta': '立即投资',

  'home.plans.loan.title': '个人贷款',
  'home.plans.loan.rate': '起始利率',
  'home.plans.loan.term': '还款期限',
  'home.plans.loan.feature1': '24 小时快速批准',
  'home.plans.loan.feature2': '无隐藏费用',
  'home.plans.loan.feature3': '灵活的 EMI 选项',
  'home.plans.loan.feature4': '最少文件要求',
  'home.plans.loan.cta': '立即申请',

  'home.testimonials.title': '客户评价',
  'home.testimonials.subtitle': '加入全球数千名满意客户的行列',

  'home.cta.title': '准备好改变您的财务未来了吗?',
  'home.cta.subtitle': '加入数百万信任 Pinnacle Payments 满足其财务需求的用户',
  'home.cta.button': '创建您的账户',

  // About Page
  'about.hero.title': '关于 Pinnacle Payments',
  'about.hero.subtitle': '自 2010 年以来引领数字金融的未来',

  'about.story.title': '我们的故事',
  'about.story.content': 'Pinnacle Payments 成立于 2010 年,源于革新金融服务行业的愿景。我们认识到传统银行业未能满足快速发展的数字世界的需求。我们的创始人是一支由金融科技先驱和银行业资深人士组成的团队,着手创建一个将尖端技术与个性化服务相结合的平台。如今,我们为 180 个国家的 800 多万客户提供服务,每年处理数十亿笔交易,同时保持我们对安全、创新和客户满意度的承诺。',

  'about.mission.title': '我们的使命',
  'about.mission.content': '为全球个人和企业提供可访问、安全和创新的金融解决方案,使他们能够实现目标并建立持久繁荣。',

  'about.vision.title': '我们的愿景',
  'about.vision.content': '成为世界上最值得信赖的数字金融平台,在金融科技行业树立卓越、安全和客户体验的新标准。',

  'about.stats.customers': '满意客户',
  'about.stats.transactions': '处理交易',
  'about.stats.countries': '全球国家',
  'about.stats.rating': '客户评分',

  'about.values.title': '我们的核心价值观',
  'about.values.security.title': '安全第一',
  'about.values.security.desc': '我们优先考虑您的资金和数据的安全。',
  'about.values.innovation.title': '创新',
  'about.values.innovation.desc': '不断发展以提供尖端的金融解决方案。',
  'about.values.transparency.title': '透明度',
  'about.values.transparency.desc': '在我们所做的一切中进行清晰的沟通和诚实的实践。',
  'about.values.excellence.title': '卓越',
  'about.values.excellence.desc': '为我们的客户提供卓越的服务和成果。',

  'about.team.title': '认识我们的领导团队',
  'about.team.subtitle': '经验丰富的专业人士推动金融科技创新',

  // FAQ Page
  'faq.title': '常见问题',
  'faq.subtitle': '查找有关我们服务的常见问题的答案',

  'faq.general': '一般',
  'faq.account': '账户',
  'faq.security': '安全',
  'faq.payments': '支付',

  // Contact Page
  'contact.title': '联系我们',
  'contact.subtitle': '我们随时为您解答任何问题或疑虑',

  'contact.info.title': '联系信息',
  'contact.info.address': '访问我们',
  'contact.info.email': '发送电子邮件',
  'contact.info.phone': '致电我们',
  'contact.info.hours': '营业时间',
  'contact.info.hoursValue': '周一至周五:上午 8:00 - 晚上 7:00 (太平洋标准时间)',

  'contact.form.title': '给我们留言',
  'contact.form.name': '全名',
  'contact.form.email': '电子邮件地址',
  'contact.form.subject': '主题',
  'contact.form.message': '消息',
  'contact.form.send': '发送消息',

  'contact.map.title': '我们的位置',
};

export default common;